import { render, staticRenderFns } from "./extract-tabs.vue?vue&type=template&id=3356bf35&scoped=true&"
import script from "./extract-tabs.vue?vue&type=script&lang=js&"
export * from "./extract-tabs.vue?vue&type=script&lang=js&"
import style0 from "./extract-tabs.vue?vue&type=style&index=0&id=3356bf35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356bf35",
  null
  
)

export default component.exports